import {
  captureeventbaseanalytics,
  capturepageanalytics,
  GetCookie,
  RemoveCookie,
  useState,
  useEffect,
  React,
  Navigate,
  Outlet,
  PageLoading,
  axios,
  BASEURL,
  toast,
} from "../../Libraries/Media";

const ProtectedRoutes = () => {
  const [state, setState] = useState({
    isLoading: true,
    data: {},
  });

  const getDataWrapper = async (es_token, txt_customer_id) => {
    const data = new FormData();
    data.append("security_token", es_token);
    data.append("txt_customer_id", txt_customer_id);

    try {
      const response = await axios({
        method: "post",
        url: BASEURL + "customer/authenticateCustomer.php",
        data: data,
        withCredentials: true,
      });

      setState({
        isLoading: false,
        data: response.data,
      });
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      setState({
        isLoading: false,
        data: {},
      });
    }
  };

  useEffect(() => {
    capturepageanalytics(window.location.pathname);
    const es_token = GetCookie("es_token");
    const txt_customer_id = localStorage.getItem("txt_customer_id");

    if (es_token && txt_customer_id) {
      getDataWrapper(es_token, txt_customer_id);
    } else {
      setState({
        isLoading: false,
        data: {},
      });
    }
  }, []);

  if (state.isLoading) {
    return <PageLoading />;
  }

  if (
    state.isLoading === false &&
    state.data.status === "true" &&
    state.data.message === "Session authenticated" &&
    state.data.connection === "true"
  ) {
    captureeventbaseanalytics(
      "AUTO LOGIN",
      "authenticateCustomer.php RESPONSE",
      state.data.message
    );
    return <Outlet />;
  } else {
    RemoveCookie("es_token");
    RemoveCookie("is_first_time_login");
    localStorage.removeItem("txt_customer_id");
    captureeventbaseanalytics(
      "AUTO LOGIN",
      "authenticateCustomer.php RESPONSE",
      state.data.message
    );
    return <Navigate to="/login" state={state} />;
  }
};
export default ProtectedRoutes;
